<template>
  <BaseSideBar
    v-if="!isSingelOrder"
    :class="[isOpenMobileSideBar ? 'pa-4' : '']"
    class="d-flex ga-6 flex-column"
  >
    <BaseSearch
      v-if="isOpenMobileSideBar || isDesktop"
      :class="[isOpenMobileSideBar || isLaptop || isDesktop ? 'mt-7' : '']"
      @update-search-word="updateUserSearchInput"
      :searchword="userSearchInput"
      :placeholder="'חיפוש לפי מס הזמנה, לקוח, כתובת, עיר'"
      isSearchHeader
      style="max-width: 500px"
      mode="orders"
    />
    <div class="">
      <!-- list of Statuses -->
      <SideBarTitle
        key="title"
        mode="orders"
        :isSideBarTitleShown="!needToCloseSideBar"
      />

      <v-divider
        v-if="isOpenMobileSideBar || isDesktop"
        length="268px"
        class="ma-5 mr-0"
      ></v-divider>
      <FiltersDisplay btnText="סגור">
        <!-- <ControlActionsButtons
            class="mt-3 mb-3"
            :ActionsList="actionList"
            :selectedAction="selectedAction"
            @selectAction="selectAction"
            mode="orders"
          /> -->
        <IconTitle
          class="pr-5"
          iconName="mdi-adjust"
          mode="orders"
          title="הזמנות בסטטוס"
        />
        <ControlActionsButtons
          class="mt-3 mb-3"
          :ActionsList="actionListStatus"
          :selectedAction="selectedStatusAction"
          @selectAction="selectStatusAction"
          mode="orders"
        />
        <v-divider length="268px" class="ma-5 mr-0"></v-divider>

        <div class="d-flex align-center ga-2 mb-2">
          <span
            @click="toggleDateMode(!isDateRangeMode)"
            class="search-text-caption"
            >{{ searchOption }}</span
          >
          <!-- <v-btn
            size="x-small"
            :color="!isDateRangeMode ? 'primary' : 'grey'"
            @click="toggleDateMode(false)"
            variant="tonal"
          >
            תאריך בודד
          </v-btn>
          <v-btn
            size="x-small"
            :color="isDateRangeMode ? 'primary' : 'grey'"
            @click="toggleDateMode(true)"
            variant="tonal"
          >
            טווח תאריכים
          </v-btn> -->
        </div>

        <div v-if="!isDateRangeMode">
          <datePickerButton
            mode="order"
            class="mb-4"
            :header="'ת.הזמנה'"
            :width="'150px'"
            @openModal="openDatePicker('orderDate')"
            :active="orderDate.trim().length > 0"
          >
            <div>
              <v-text-field
                class="flex-1-0 date-picker pr-3"
                hide-details="auto"
                :append-inner-icon="
                  orderDate ? 'mdi-close' : 'mdi-calendar-range'
                "
                :model-value="formattedDate(orderDate, 'ת.הזמנה')"
                variant="plain"
                style="pointer-events: none"
              ></v-text-field>
            </div>
          </datePickerButton>
        </div>

        <div v-else class="d-flex ga-3">
          <datePickerButton
            mode="order"
            class="mb-4"
            :header="'מתאריך'"
            :width="'150px'"
            @openModal="openDatePicker('orderDateFrom')"
            :active="orderDateFrom.trim().length > 0"
          >
            <div>
              <v-text-field
                class="flex-1-0 date-picker pr-3"
                hide-details="auto"
                :append-inner-icon="
                  orderDateFrom ? 'mdi-close' : 'mdi-calendar-range'
                "
                :model-value="formattedDate(orderDateFrom, 'מתאריך')"
                variant="plain"
                style="pointer-events: none"
              ></v-text-field>
            </div>
          </datePickerButton>

          <datePickerButton
            mode="order"
            class="mb-4"
            :header="'עד תאריך'"
            :width="'150px'"
            @openModal="openDatePicker('orderDateTo')"
            :active="orderDateTo.trim().length > 0"
          >
            <div>
              <v-text-field
                class="flex-1-0 date-picker pr-3"
                hide-details="auto"
                :append-inner-icon="
                  orderDateTo ? 'mdi-close' : 'mdi-calendar-range'
                "
                :model-value="formattedDate(orderDateTo, 'עד תאריך')"
                variant="plain"
                style="pointer-events: none"
              ></v-text-field>
            </div>
          </datePickerButton>
        </div>

        <div class="d-flex flex-column ga-4 position-relative">
          <SideBarList
            :Categories="getFilters?.distlines"
            queryKey="distLine"
            defaultValue="קו חלוקה"
            mode="orders"
          />

          <SideBarList
            v-if="getUserRole?.agentapp"
            :Categories="getFilters?.agents"
            queryKey="agentId"
            defaultValue="סוכן"
            mode="orders"
          />

          <SideBarList
            v-if="false"
            :Categories="getFilters?.customers"
            queryKey="custId"
            defaultValue="לקוח"
            mode="orders"
          />

          <SideBarList
            :Categories="filteredStatuses"
            queryKey="status"
            defaultValue="סטטוס"
            mode="orders"
          />
        </div>
      </FiltersDisplay>
    </div>
    <datePickerModal
      @update:modelValue="updateDate"
      @trigger-date-picker-update="updateDate"
      :openModal="openModalDatePicker"
    />
  </BaseSideBar>
  <BaseSideBar v-else-if="isDesktop">
    <SingelOrderBackBtn />
  </BaseSideBar>
</template>

<script>
import BaseSideBar from "./BaseSideBar.vue";
import { mapGetters } from "vuex";
import SideBarTitle from "./SideBarTitle.vue";
import SideBarList from "./SideBarList.vue";
import ControlActionsButtons from "../helpers/controlActionsButtons.vue";
import datePickerButton from "@/components/UI/datePickerButton.vue";
import datePickerModal from "@/components/UI/modals/datePickerModal.vue";
import { dateToDisplay } from "@/dates";
import FiltersDisplay from "./FiltersDisplay.vue";
import BaseSearch from "./BaseSearch.vue";
import moment from "moment";
import IconTitle from "../UI/IconTitle.vue";
import SingelOrderBackBtn from "../helpers/SingelOrderBackBtn.vue";

export default {
  components: {
    BaseSideBar,
    SideBarTitle,
    SideBarList,
    ControlActionsButtons,
    datePickerButton,
    datePickerModal,
    FiltersDisplay,
    BaseSearch,
    IconTitle,
    SingelOrderBackBtn,
  },
  data() {
    return {
      selectedAction: "כל ההזמנות",
      selectedStatusAction: "הכל",
      orderDate: "",
      orderDateFrom: "",
      orderDateTo: "",
      isDateRangeMode: false,
      currentDateField: "",
      openModalDatePicker: false,
      userSearchInput: "",
      actionList: [
        { name: "כל ההזמנות", path: "allorders" },
        { name: "הזמנות למחר", path: "tommorroworders" },
      ],
      actionListStatus: [
        { name: "הכל", path: "all" },
        { name: "נקלטה", path: "2" },
        { name: "אושרה להפצה", path: "7" },
      ],
    };
  },
  mounted() {
    // Detect mode based on query params
    if (this.$route.query.orderDateFrom || this.$route.query.orderDateTo) {
      this.isDateRangeMode = true;
      if (this.$route.query.orderDateFrom) {
        this.orderDateFrom = this.$route.query.orderDateFrom;
      }
      if (this.$route.query.orderDateTo) {
        this.orderDateTo = this.$route.query.orderDateTo;
      }
    } else if (this.$route.query.orderDate) {
      this.isDateRangeMode = false;
      this.orderDate = this.$route.query.orderDate;
    }
    // this.applyPaginationFilter();
    const path = this.getPathParam();
    let currentAction = this.actionList.find((action) => action.path === path);
    if (currentAction) {
      this.selectAction(currentAction);
    }
    const statusQuery = this.$route.query.mainStatus;
    if (statusQuery) {
      let currentSelectAction = this.actionListStatus.find(
        (action) => action.path === statusQuery,
      );
      this.selectStatusAction(currentSelectAction);
    }
  },
  unmounted() {
    this.$store.commit("setIsOpenMobileSideBar", false);
  },

  watch: {
    "$route.query.orderDate"() {
      if (this.$route.query.orderDate) {
        this.orderDate = this.$route.query.orderDate;
      } else {
        this.orderDate = "";
      }
    },
    "$route.query.orderDateFrom"() {
      if (this.$route.query.orderDateFrom) {
        this.orderDateFrom = this.$route.query.orderDateFrom;
      } else {
        this.orderDateFrom = "";
      }
    },
    "$route.query.orderDateTo"() {
      if (this.$route.query.orderDateTo) {
        this.orderDateTo = this.$route.query.orderDateTo;
      } else {
        this.orderDateTo = "";
      }
    },
    "$route.query.mainStatus"() {
      const foundCurrentStatusPath = this.actionListStatus.find(
        (action) => action.path === this.$route.query.mainStatus,
      );
      if (foundCurrentStatusPath) {
        this.selectedStatusAction = foundCurrentStatusPath.name;
      } else {
        this.selectedStatusAction = "הכל";
      }
    },
    "$route.params.category"() {
      const foundCurrentCategoryPath = this.actionList.find(
        (action) => action.path === this.$route.params.category,
      );
      if (foundCurrentCategoryPath) {
        this.selectedAction = foundCurrentCategoryPath.name;
      } else {
        this.selectedAction = "כל ההזמנות";
      }
    },
    "$route.query"() {
      this.applyPaginationFilter();
    },
  },
  methods: {
    getPathParam() {
      let path = this.$route.path;
      if (path.includes("/")) {
        path = path.length > 2 ? path.split("/")[2] : path;
      }
      return path;
    },
    async applyPaginationFilter() {
      const path = this.getPathParam();
      const query = {
        ...this.$route.query,
        [path]: path,
      };
      if (query?.status) {
        this.selectedStatusAction = "הכל";
      }
      await this.$store.dispatch("Orders/getOrdersPagination", query);
    },
    updateUserSearchInput(value) {
      this.userSearchInput = value;
    },
    updateDate(date) {
      this.openModalDatePicker = false;
      let query = { ...this.$route.query };

      if (this.currentDateField === "orderDate") {
        if (date) {
          this.orderDate = moment(date).startOf('day').toISOString();
          query.orderDate = this.orderDate;
        } else {
          this.orderDate = "";
          delete query.orderDate;
        }
      } else if (this.currentDateField === "orderDateFrom") {
        if (date) {
          this.orderDateFrom = moment(date).startOf('day').toISOString();
          query.orderDateFrom = this.orderDateFrom;
        } else {
          this.orderDateFrom = "";
          delete query.orderDateFrom;
        }
      } else if (this.currentDateField === "orderDateTo") {
        if (date) {
          this.orderDateTo = moment(date).startOf('day').toISOString();
          query.orderDateTo = this.orderDateTo;
        } else {
          this.orderDateTo = "";
          delete query.orderDateTo;
        }
      }

      this.$router.push({ path: `${this.$route.path}`, query: query });
    },
    openDatePicker(field) {
      this.currentDateField = field;
      let dateValue = "";

      if (field === "orderDate") {
        dateValue = this.orderDate;
      } else if (field === "orderDateFrom") {
        dateValue = this.orderDateFrom;
      } else if (field === "orderDateTo") {
        dateValue = this.orderDateTo;
      }

      if (!dateValue) {
        this.openModalDatePicker = true;
      } else {
        this.updateDate(null);
      }
    },
    toggleDateMode(isRange) {
      this.isDateRangeMode = isRange;
      let query = { ...this.$route.query };

      if (isRange) {
        // Switch to range mode: remove orderDate
        delete query.orderDate;
        this.orderDate = "";
      } else {
        // Switch to single mode: remove orderDateFrom and orderDateTo
        delete query.orderDateFrom;
        delete query.orderDateTo;
        this.orderDateFrom = "";
        this.orderDateTo = "";
      }

      this.$router.push({ path: `${this.$route.path}`, query: query });
    },
    formattedDate(date, text) {
      if (!date) return text;
      return dateToDisplay(date);
    },
    selectStatusAction(action) {
      this.selectedStatusAction = action?.name;
      const query = {
        ...this.$route.query,
        mainStatus: action?.path,
      };
      if (query.status) {
        delete query.status;
      }
      if (action?.path === "all") {
        delete query.mainStatus;
      }
      this.$router.push({ query: query });
    },
    selectAction(action) {
      this.selectedAction = action.name;
      console.log(action.path);
      const query = {
        ...this.$route.query,
      };
      this.$router.push({ path: action.path, query: query });
    },
  },
  computed: {
    searchOption() {
      return !this.isDateRangeMode ? "בחירת טווח תאריכים" : "בחירת תאריך בודד";
    },
    filteredStatuses() {
      return this.getFilters?.statuses.filter(
        (status) => status.id !== 2 && status.id !== 7,
      );
    },
    isSingelOrder() {
      return this.$route.name === "Order";
    },
    isLangHebrew() {
      return this.getUserLang == "he" ? true : false;
    },
    needToCloseSideBar() {
      if (
        (this.$store.getters.isMobile || this.$store.getters.isTablet) &&
        !this.$store.state.openMenu
      ) {
        // this.$store.commit("toggleMenu");
        return true;
      } else {
        return false;
      }
    },
    ...mapGetters({
      getOrdersStatuses: "Orders/getOrdersStatuses",
      getOrdersAgents: "Orders/getOrdersAgents",
      getOrdersDistLines: "Orders/getOrdersDistLines",
      getOrdersCustomers: "Orders/getOrdersCustomers",
      getFilters: "ControlPanel/getFilters",
      isTablet: "isTablet",
      isLaptop: "isLaptop",
      isDesktop: "isDesktop",
      isOpenMobileSideBar: "isOpenMobileSideBar",
      getUserRole: "AuthModule/getUserRole",
    }),
    getParamStatus() {
      return this.$route.params.status;
    },
  },
};
</script>

<style scoped lang="scss">
.title-section {
  padding: 0px 20px 0px 20px;
}
.search-text-caption {
  font-size: 20px;
  text-decoration: underline;
  margin-right: 15px;
  cursor: pointer;
}
.orders-icon {
  color: $ordersMainColor;
  background-color: #44a5e233;
  border-radius: 50%;
  padding: 17px;
}
@media (max-width: 601px) {
  .side-bar-container {
    // padding: unset;
  }
}
h2 {
  font-size: 30px;
  font-weight: 700;
  color: $ordersMainColor;
  line-height: 35.55px;
  text-align: right;
}

.material-icons {
  font-size: unset;
}
.collection-item {
  text-decoration: none;
  span {
    font-weight: 400;
    padding: 10px;
  }
}
.menu-collection {
  .v-list-item-title {
    font-size: $mediumTextSize;
    font-weight: 400;
    line-height: 21.33px;
    text-align: right;
    color: $statusListColor;
  }
}
</style>
